import { settingConstants } from "../constants";
import { settingService } from "../services";
//import { alertActions, loaderMaskActions } from './';
import { handleErrors } from "../../utils";

export const settingActions = {
  getAvailableTimeZones,
  getAvailableUsers,
  changeUserTimeZone,
  changePageItemCount,

  changeUserLanguage,

  changeUserEmail,

  changeNewUserState,

  changeUserGridsSettings,

  getChannnelList,

  updateChannelList,

  getPlatformsList,

  updatePlatformList,

  getSlaCalenderList,
};

function updatePlatformList(platforms) {
  return { type: settingConstants.GET_PLATFORM_LIST_SUCCESS, platforms };
}

function updateChannelList(channels) {
  return { type: settingConstants.GET_CHANNEL_LIST_SUCCESS, channels };
}

function getPlatformsList() {
  return (dispatch) => {
    dispatch(request());

    settingService.getPlatformsList().then(
      (platforms) => dispatch(success(platforms)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: settingConstants.GET_PLATFORM_LIST_REQUEST };
  }

  function success(platforms) {
    return { type: settingConstants.GET_PLATFORM_LIST_SUCCESS, platforms };
  }

  function failure(error) {
    return { type: settingConstants.GET_PLATFORM_LIST_FAILURE, error };
  }
}

function getChannnelList() {
  return (dispatch) => {
    dispatch(request());

    settingService.getChannnelList().then(
      (channels) => dispatch(success(channels)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: settingConstants.GET_CHANNEL_LIST_REQUEST };
  }

  function success(channels) {
    return { type: settingConstants.GET_CHANNEL_LIST_SUCCESS, channels };
  }

  function failure(error) {
    return { type: settingConstants.GET_CHANNEL_LIST_FAILURE, error };
  }
}

function getSlaCalenderList() {
  return (dispatch) => {
    dispatch(request());

    settingService.getSlaCalenderList().then(
      (slaCalenders) => dispatch(success(slaCalenders)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: settingConstants.GET_SLA_CALENDER_LIST_REQUEST };
  }

  function success(slaCalenders) {
    return {
      type: settingConstants.GET_SLA_CALENDER_LIST_SUCCESS,
      slaCalenders,
    };
  }

  function failure(error) {
    return { type: settingConstants.GET_SLA_CALENDER_LIST_FAILURE, error };
  }
}

function getAvailableTimeZones() {
  return (dispatch) => {
    dispatch(request());

    settingService.getAvailableTimeZones().then(
      (timeZones) => dispatch(success(timeZones)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: settingConstants.GETALL_TZ_REQUEST };
  }

  function success(timeZones) {
    return { type: settingConstants.GETALL_TZ_SUCCESS, timeZones };
  }

  function failure(error) {
    return { type: settingConstants.GETALL_TZ_FAILURE, error };
  }
}

function getAvailableUsers() {
  return (dispatch) => {
    dispatch(request());

    settingService.getAvailableUsers().then(
      (timeZones) => dispatch(success(timeZones)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: settingConstants.GETALL_USER_REQUEST };
  }

  function success(timeZones) {
    return { type: settingConstants.GETALL_USER_SUCCESS, timeZones };
  }

  function failure(error) {
    return { type: settingConstants.GETALL_USER_FAILURE, error };
  }
}

function changeUserTimeZone(newTimeZoneValue, currentUser) {
  return (dispatch) => {
    dispatch(request());
    settingService
      .changeUserSettings({ ...currentUser, timeZone: newTimeZoneValue })
      .then(
        (userSettings) => dispatch(success(userSettings)),
        (error) => {
          handleErrors(error, dispatch);
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: settingConstants.CHANGE_SETTINGS_REQUEST };
  }

  function success(userSettings) {
    return { type: settingConstants.CHANGE_SETTINGS_SUCCESS, userSettings };
  }

  function failure(error) {
    return { type: settingConstants.CHANGE_SETTINGS_FAILURE, error };
  }
}

function changePageItemCount(newPageItemCountValue, currentUser) {
  return (dispatch) => {
    dispatch(request());
    settingService
      .changeUserSettings({
        ...currentUser,
        pageItemCount: newPageItemCountValue,
      })
      .then(
        (userSettings) => dispatch(success(userSettings)),
        (error) => {
          handleErrors(error, dispatch);
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: settingConstants.CHANGE_SETTINGS_REQUEST };
  }

  function success(userSettings) {
    return { type: settingConstants.CHANGE_SETTINGS_SUCCESS, userSettings };
  }

  function failure(error) {
    return { type: settingConstants.CHANGE_SETTINGS_FAILURE, error };
  }
}

function changeUserLanguage(newLanguageValue, currentUser) {
  return (dispatch) => {
    dispatch(request());
    settingService
      .changeUserSettings({
        ...currentUser,
        language: newLanguageValue,
      })
      .then(
        (userSettings) => dispatch(success(userSettings)),
        (error) => {
          handleErrors(error, dispatch);
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: settingConstants.CHANGE_SETTINGS_REQUEST };
  }

  function success(userSettings) {
    return { type: settingConstants.CHANGE_SETTINGS_SUCCESS, userSettings };
  }

  function failure(error) {
    return { type: settingConstants.CHANGE_SETTINGS_FAILURE, error };
  }
}

function changeUserEmail(newEmail, currentUser) {
  return (dispatch) => {
    dispatch(request());
    settingService
      .changeUserSettings({
        ...currentUser,
        email: newEmail,
      })
      .then(
        (userSettings) => dispatch(success(userSettings)),
        (error) => {
          handleErrors(error, dispatch);
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: settingConstants.CHANGE_SETTINGS_REQUEST };
  }

  function success(userSettings) {
    return { type: settingConstants.CHANGE_SETTINGS_SUCCESS, userSettings };
  }

  function failure(error) {
    return { type: settingConstants.CHANGE_SETTINGS_FAILURE, error };
  }
}

function changeNewUserState(newUser, currentUser) {
  //TODO call server method in order to change the new user state
  return {
    type: settingConstants.CHANGE_SETTINGS_SUCCESS,
    userSettings: { ...currentUser, newUser },
  };
}

function changeUserGridsSettings(gridsSettings, currentUser) {
  return (dispatch) => {
    dispatch(request());
    settingService
      .changeUserSettings({
        ...currentUser,
        gridsSettings,
      })
      .then(
        (userSettings) => dispatch(success(userSettings)),
        (error) => {
          handleErrors(error, dispatch);
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: settingConstants.CHANGE_SETTINGS_REQUEST };
  }

  function success(userSettings) {
    return { type: settingConstants.CHANGE_SETTINGS_SUCCESS, userSettings };
  }

  function failure(error) {
    return { type: settingConstants.CHANGE_SETTINGS_FAILURE, error };
  }
}
